/** Quiet web entrance. Not linked from the landing or the app. */
export const ADMIN_WEB_LOGIN_PATH = '/hp-admin';

export const ADMIN_WEB_EMAILS = [
  'marina.simaganova@gmail.com',
  'romanova.marina.dev@gmail.com',
];

export function isAdminWebEmail(email) {
  const normalized = (email || '').trim().toLowerCase();
  return ADMIN_WEB_EMAILS.includes(normalized);
}
